export default __webpack_public_path__ + "static/media/RivoluzioneacorrentecontinuaWartsilainveste7milioni.947ecca3.pdf";